import { sum } from 'lodash';
import React from 'react';
import { TrendingDown, TrendingUp } from 'react-feather';
import styled from '../styled';
import { Scores } from '../types/Ranking';

const UpArrow = styled('span')`
  display: block;
  color: #25d787;
  margin: 0 auto;
`;

const DownArrow = styled('span')`
  display: block;
  color: #ff4d4f;
  margin: 0 auto;
`;

const TrendArrow = ({
  curr,
  prev,
  size
}: {
  size: PointsSize;
  curr: number;
  prev: number;
}) => {
  if (curr === prev) {
    return null;
  }

  const SIZE = size === 'normal' ? 24 : 18;

  if (curr > prev) {
    return (
      <UpArrow>
        <TrendingUp size={SIZE} />
      </UpArrow>
    );
  }
  return (
    <DownArrow>
      <TrendingDown size={SIZE} />
    </DownArrow>
  );
};

const PointsWrapper = styled('div')`
  background: #111216;
  grid-area: points;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  text-align: center;
  align-content: center;
  border-radius: ${(p) => p.theme.shape.borderRadius}px;
  height: 100%;
`;

const PointsNumber = styled<'div', { size: PointsSize }>('div')`
  font-size: ${(p) => (p.size === 'normal' ? 24 : 18)}px;
  font-weight: 600;
`;

const PointsText = styled<'div', { size: PointsSize }>('div')`
  color: ${(p) => p.theme.palette.grey[400]};
  font-size: ${(p) => (p.size === 'normal' ? 16 : 12)}px;
`;

type PointsSize = 'normal' | 'small';

const MiniPointsWrapper = styled('span')`
  display: flex;
  align-items: center;
  padding: 2px 4px;
  background: #111216;
  border-radius: 4px;
  font-size: 12px;
  color: ${(p) => p.theme.palette.grey[200]};

  svg {
    margin-left: ${(p) => p.theme.spacing(1)}px;
  }
`;

export const MiniPoints = ({
  scores,
  scoreRange
}: {
  scores: Scores;
  scoreRange: number;
}) => {
  const curr = sum(scores.scoresByDay.slice(-scoreRange));
  const prev = sum(scores.scoresByDay.slice(-scoreRange * 2, -scoreRange));

  return (
    <MiniPointsWrapper>
      <span>{curr.toLocaleString('en-US')}</span>
      <TrendArrow size="small" curr={curr} prev={prev} />
    </MiniPointsWrapper>
  );
};

export const toPoints = (scores: Scores, scoreRange: number) => {
  return sum(scores.scoresByDay.slice(-scoreRange));
};

export const Points = ({
  scores: scores,
  size = 'normal',
  style = {},
  scoreRange
}: {
  size?: PointsSize;
  style?: React.CSSProperties;
  scores: Scores;
  scoreRange: number;
}) => {
  const curr = sum(scores.scoresByDay.slice(-scoreRange));
  const prev = sum(scores.scoresByDay.slice(-scoreRange * 2, -scoreRange));

  return (
    <PointsWrapper style={style}>
      <TrendArrow size={size} curr={curr} prev={prev} />
      <PointsNumber size={size}>{curr.toLocaleString('en-US')}</PointsNumber>
      <PointsText size={size}>points</PointsText>
    </PointsWrapper>
  );
};
